module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAA6ElEQVRIS+2V0Q3CMAxEr5vAJMAkwCTAJMAkwCTAJKBDNrLS4DoB5adE6keT2M+5c9MODUbXgIFayArAGcAtUmQNZA7gJJB1BFQDYfFbAJsoqARCiZZGHp6Ig7K5J4pCrgAmIo36wHedm3reRCB7ADwFqz1IMr5znkAXwP0WwsBZUtHRJFvImhqvgFzcXXx7hVjII9MprJ4Vq+5aA43nQwAbIB2U8Z07hVhJNJB+pBDPApVypBB6cjGdNXSTVMk1lDRd/0OKFBuRXLuCVv2koV412S9er/MiA5zNWcivkvfyRP4nX8ObQJ7tWUoauXn7PQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landscape.png
// module id = Mbp8
// module chunks = 2